'use client';
import type React from 'react';

import { NavItem } from '../navbar/nav-item';
import Logo from '../../../../public/skybeam-logo-with-text-with-tm.svg';
import Facebook from '../../../../public/facebook-logo.svg';
import Linkedin from '../../../../public/linkedin-logo.svg';
import X from '../../../../public/x-logo.svg';

const navItems = [
  { link: '/blog', label: 'Blog' },
  { link: '/pricing', label: 'Pricing' },
  { link: '/about', label: 'About Us' },
  { link: 'https://help.simulmedia.com/', label: 'Help Center' },
  { link: '/terms-of-services', label: 'Terms of Services' },
  { link: '/privacy-policy', label: 'Privacy Policy' },
  { link: '/product/d2cx', label: 'D2Cx' },
];

export const Footer: React.FC = () => {
  return (
    <div className="tablet:py-12 tablet:px-8 flex justify-center bg-[#0A0A0A] px-4 py-6">
      <div className="tablet:max-w-[572px] laptop:max-w-[880px] desktop:max-w-284 flex w-full max-w-full flex-col gap-y-6">
        <div className="desktop:flex-row desktop:items-center desktop:justify-between desktop:gap-x-16 flex flex-col items-start gap-y-6">
          <div
            data-test="marketing-footer"
            className="tablet:gap-6 laptop:gap-x-8 flex flex-wrap items-center gap-x-6 gap-y-4 text-[0.875rem] text-white"
          >
            {navItems.map(({ label, link }) => (
              <NavItem key={`footer-${label}`} href={link}>
                <p className="tracking-normal">{label}</p>
              </NavItem>
            ))}
          </div>
          <div
            data-test="marketing-social-networks"
            className="flex gap-x-6 text-transparent"
          >
            <NavItem href="https://www.linkedin.com/company/skybeam-io/">
              <Linkedin />
            </NavItem>
            <NavItem href="https://www.facebook.com/skybeam.tv.ads/">
              <Facebook />
            </NavItem>
            <NavItem href="https://x.com/Skybeam_TV_Ads">
              <X />
            </NavItem>
          </div>
        </div>
        <div className="laptop:flex-row laptop:items-center laptop:gap-x-8 flex flex-col items-start gap-y-4 text-base leading-normal text-gray-400">
          <NavItem href="/">
            <Logo className="m-0 h-[31px]" viewBox="0 0 133 32" />
          </NavItem>
          <p>2026 Skybeam™, a division of Simulmedia. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};
